

interface Props {
    years: number[];
    visibleYears: Set<number>;
    canMoveBackward: boolean;
    canMoveForward: boolean;
    // Offset is a number of quarters; year arrows move four quarters.
    onMove: (offset: number) => void;
    onShowYear: (year: number) => void;
}

export function CalendarNavigation({
    years, visibleYears, canMoveBackward, canMoveForward, onMove, onShowYear,
}: Props) {
    return (
        <div className='report-calendar-navigation'>
            <div className='report-calendar-navigation__buttons'>
                <button
                    type='button'
                    disabled={!canMoveBackward}
                    aria-label='Show previous year'
                    title='Previous year'
                    onClick={() => onMove(-4)}
                >
                    &laquo;
                </button>
                <button
                    type='button'
                    disabled={!canMoveBackward}
                    aria-label='Show previous quarter'
                    title='Previous quarter'
                    onClick={() => onMove(-1)}
                >
                    &lsaquo;
                </button>
            </div>
            {/* Highlight the years shown in the calendar, regardless of the selected report dates. */}
            <div className='report-calendar-years' aria-label='Jump to year'>
                {years.map((year) => (
                    <button
                        type='button'
                        key={year}
                        className={visibleYears.has(year) ? 'visible' : undefined}
                        onClick={() => onShowYear(year)}
                    >
                        {year}
                    </button>
                ))}
            </div>
            <div className='report-calendar-navigation__buttons'>
                <button
                    type='button'
                    disabled={!canMoveForward}
                    aria-label='Show next quarter'
                    title='Next quarter'
                    onClick={() => onMove(1)}
                >
                    &rsaquo;
                </button>
                <button
                    type='button'
                    disabled={!canMoveForward}
                    aria-label='Show next year'
                    title='Next year'
                    onClick={() => onMove(4)}
                >
                    &raquo;
                </button>
            </div>
        </div>
    );
}
